<template>
    <div class="card position-sticky top-1 mt-4">
      <ul class="nav flex-column bg-white border-radius-lg p-3">        
        <li class="nav-item pt-2">
          <a class="nav-link text-dark d-flex" data-scroll href="#association-info">
            <i class="material-symbols-rounded text-lg me-2">info</i>
            <span class="text-sm">{{ $t('association.Association_info') }}</span>
          </a>
        </li>
        <li class="nav-item pt-2">
          <a class="nav-link text-dark d-flex" data-scroll href="#address">
            <i class="material-symbols-rounded text-lg me-2">contacts</i>
            <span class="text-sm">{{ $t('association.Address') }}</span>
          </a>
        </li>
        <li class="nav-item pt-2">
          <a class="nav-link text-dark d-flex" data-scroll href="#webemail">
            <i class="material-symbols-rounded text-lg me-2">captive_portal</i>
            <span class="text-sm">{{ $t('association.Web_and_email_info') }}</span>
          </a>
        </li>
        <li class="nav-item pt-2">
          <a class="nav-link text-dark d-flex" data-scroll href="#logoimage">
            <i class="material-symbols-rounded text-lg me-2">image</i>
            <span class="text-sm">{{ $t('association.Logo_image') }}</span>
          </a>
        </li>        
        <li class="nav-item pt-2">
          <a class="nav-link text-dark d-flex" data-scroll href="#delete">
            <i class="material-symbols-rounded text-lg me-2">delete</i>
            <span class="text-sm">{{ $t('association.Delete_association') }}</span>
          </a>
        </li>
      </ul>
    </div>
  </template>
  
  <script>
  export default {
    name: "EditAssociationSideNav",
  };
  </script>
  